import User from '../models/user.model';
import { parseCanSeePermission } from '../utils/canSeePermission';

export class UserFactory {
  static CreateUser(userData) {
    const user = new User();
    user.id = userData.userId ?? userData.user_id ?? userData._id ?? userData.id;
    user._id = userData._id ?? userData.userId ?? userData.user_id;
    user.firstName = userData.firstName;
    user.lastName = userData.lastName;
    user.dealershipName = userData.dealershipName;
    user.email = userData.email;
    user.exp = userData.exp;
    user.permissions = userData.permissions;
    user.pictureUrl = userData.pictureUrl;
    user.role = userData.role;
    user.username = userData.username;
    user.carsBoughtLastMonth = userData.carsBoughtLastMonth || 0;
    user.status = userData.status || '';
    user.phone = userData.profile ? userData.profile.phone : null;
    user.firstLoginAt =
      userData.firstLoginAt ??
      userData.first_login_at ??
      userData.firstLogin ??
      userData.first_login ??
      userData.profile?.firstLoginAt ??
      userData.profile?.first_login_at ??
      null;
    user.promoEligible = userData.promoEligible ?? userData.promo_eligible;
    user.canSeeFipePrice = parseCanSeePermission(
      userData.canSeeFipePrice,
      userData.can_see_fipe_price,
      userData.profile?.canSeeFipePrice,
      userData.profile?.can_see_fipe_price
    );
    user.canSeeNegotiateExclusively = parseCanSeePermission(
      userData.canSeeNegotiateExclusively,
      userData.can_see_negotiate_exclusively,
      userData.profile?.canSeeNegotiateExclusively,
      userData.profile?.can_see_negotiate_exclusively
    );
    user.canSeeGuaranteedPurchase = parseCanSeePermission(
      userData.canSeeGuaranteedPurchase,
      userData.can_see_guaranteed_purchase,
      userData.profile?.canSeeGuaranteedPurchase,
      userData.profile?.can_see_guaranteed_purchase
    );
    return user;
  }
}
